/* @flow */

import * as React from 'react';
import { connect } from 'react-redux';
import { get } from 'lodash/fp';
import styled from '@emotion/styled';
import ConnectedSocialShareButtons from 'app/components/commons/ConnectedSocialShareButtons';
import { IN_PROGRESS } from 'app/constants/challengeStatusTypes';

type Props = {
  displayFacebook: boolean,
  displayTwitter: boolean,
  displayEmail: boolean
};

const ShareContainer = styled.div(
  {
    display: 'flex',
    position: 'relative'
  },
  ({ theme }) => ({
    fontSize: theme.fontSize.tiny
  })
);

const ChallengeSocialShareButtons: React.FC = ({
  displayFacebook,
  displayTwitter,
  displayEmail
}: Props) => (
  <ShareContainer>
    <ConnectedSocialShareButtons
      clipboard
      email={displayEmail}
      facebook={displayFacebook}
      twitter={displayTwitter}
    />
  </ShareContainer>
);

function mapStateToProps(state, { statusId = 0 }) {
  const enableChallengeSocialShare = !!get('settings.social.enableChallengeSocialShare', state);

  return {
    displayEmail: enableChallengeSocialShare && state.user.isSignedIn && statusId < IN_PROGRESS,
    displayFacebook: enableChallengeSocialShare && state.settings.social.displayFacebook,
    displayTwitter: enableChallengeSocialShare && state.settings.social.displayTwitter
  };
}

export default connect(mapStateToProps)(ChallengeSocialShareButtons);
